// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"windy"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 12H5.5C4.11929 12 3 10.8807 3 9.5C3 8.11929 4.11929 7 5.5 7H7M16 4H13C11.8954 4 11 4.89543 11 6C11 7.10457 11.8954 8 13 8H21M17 16H8C6.89543 16 6 16.8954 6 18C6 19.1046 6.89543 20 8 20H11.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WindyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'windy',
    ref,
    icon: element,
  },
));

WindyIcon.displayName = 'WindyIcon';

export default WindyIcon;
